/**
 * this module is used to store all common client app base configuration flags
 */

module.exports = {
	isServer: false,		// is this a server side config
	isClient: true,			// is this a client side config
	useFecClient: false,	// some preparation steps have to be done only if the fec-client will be used.
	fecClientConfig: {		// if useFecClient is true this config is used to bundle the slimmest possible fec client necessary for the actual project

	},
	heartbeatConfig: {
		turnedOn: false, // heartbeat server-side-events may be used if granted.
		authenticatedClientsOnly: true, // trigger heartbeats only for authenticated clients. NOTE: this may be overwritten by the heartbeat itself.
	},
	bindTouchableEvents: false,
	routes: {
		api: '/api'
	},
	store: {
		name: 'ThisShouldBeOverwrittenByTheUseCaseConfigStore',
		maxAge: 2 * 60 * 60 * 1000,
		cookie: {
			policy: {
				acceptTrackingDefault: null,	// true => accepted, false => not accepted, null => not decided yet
				acceptTrackingByDefault: false	// this flag decides what to do until the user has decided if he want's to grant or deny tracking cookies
			}
		}
	},
	i18next: {
		ns: ['common','error'],
		defaultNS: 'common',
		debug: false,
		lng: 'de-at',
		lngs: ['de-at'],
		// fallbackLng: ['de-at']
	},
	credentials: {
		reLoginAction: 'credentials.showReLogin', // which action should be performed if a re-login is necessary
	},
	momentConfig: {
		timeZone: 'Europe/Vienna', 	// utils.moment will use this timezone for each new moment object if no timezone has been specified.
		locale: 'de'				// utils.moment will use this locale for each new moment object if no locale has been specified.
	},
	cache: {
		reuseCachedHtml: true,				// should the previously rendered html (identified by routes) be reused or not (in case of real apps using privileges and online periods caching must not be enabled)
		storeBuildMemoryPermanently: true, 	// should the buildMemory (trees, mappings, ...) be permanently stored within the componentTree instance or be deleted directly after the response has been sent?
		grantCacheByETag: false,			// should the fec client be allowed to cache requests based on etag?
	},
	requestIDFallback: 'client',
	sessionIDFallback: 'client',
	serviceDomainFallback: 'client',
	error: {
		handleClientError: true
	},
	debug: {
		fallbackConsole: false,
		componentListDebugging: false,
		checkForMultipleComponentOccurrences: false,
	},
	defaultTimeZone: 		'Europe/Vienna',
	defaultMomentLocale: 	'de',

	timeMeasurement: false,
	statusControllerActionHandling: false,
	validator: {
		defaultLocale: 'de-DE',
		defaultIPVersion: 4,
		defaultISBNVersion: 13,
		defaultUUIDVersion: 4
	},
	useIDSelector: false, // use id as selectors for components (results in significant client side sizzle speedup for apps like the cms)
	inject: {
		selectors: true,			// should the component-data-index or id be injected
		componentClasses: true,		// should the component class be injected as css-class
		loadingClass: true,			// should the "loading"-class be injected as css-class (used for fec-clients only)
	    anchors: true,            	// inject html anchor tag for components to enable anchors based on componentInstanceID and componentName. this may only work if the component's config.anchorInjectionGranted=true grants the anchor usage.
	},

	envOverride: { // overrides original config based on NODE_ENV variable
		// development: {
		// 	useIDSelector: true,
		// },
	},
};
